import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import API from '../../utils/api';
import toast from 'react-hot-toast';

const empty = { name:'', role:'science_teacher', duration_days:30, exam_limit:20, price:199, description:'', ai_credits:0 };

export default function AdminPlans() {
  const [plans, setPlans] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => API.get('/admin/plans').then(r => setPlans(r.data));
  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const openModal = (plan = null) => {
    if (plan) {
      setForm({ name:plan.name, role:plan.role, duration_days:plan.duration_days, exam_limit:plan.exam_limit, price:plan.price, description:plan.description||'', ai_credits:plan.ai_credits||0 });
      setEditId(plan.id);
    } else {
      setForm(empty); setEditId(null);
    }
    setModal(true);
  };

  const save = async e => {
    e.preventDefault();
    try {
      if (editId) { await API.put(`/admin/plans/${editId}`, { ...form, is_active:1 }); }
      else await API.post('/admin/plans', form);
      toast.success('✅ Plan saved!');
      setModal(false); load();
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
  };

  const del = async id => {
    if (!window.confirm('Delete this plan?')) return;
    await API.delete(`/admin/plans/${id}`);
    toast.success('Deleted'); load();
  };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth:1200, margin:'0 auto', padding:'32px 20px' }}>
        <div className="page-header flex-between">
          <div><h1>📦 Subscription Plans</h1><p>Plans are paid via Razorpay — just set the price!</p></div>
          <button className="btn btn-primary" onClick={() => openModal()}>➕ Add Plan</button>
        </div>

        <div className="grid-3">
          {plans.map(p => (
            <div key={p.id} className="card">
              <div className="flex-between mb-4">
                <span className="badge badge-primary">{p.role.replace(/_/g,' ')}</span>
                <span style={{ fontWeight:800, fontSize:22, color:'var(--primary-light)' }}>₹{p.price}</span>
              </div>
              <h3 style={{ fontWeight:700, marginBottom:6 }}>{p.name}</h3>
              {p.description && <p style={{ color:'var(--text2)', fontSize:13, marginBottom:10 }}>{p.description}</p>}
              <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:12 }}>
                <span className="badge badge-info">📅 {p.duration_days} days</span>
                <span className="badge badge-success">📝 {p.exam_limit} exams</span>
                {p.ai_credits > 0 && <span className="badge badge-warning">🤖 {p.ai_credits} AI credits</span>}
              </div>
              <div style={{ background:'rgba(99,102,241,0.1)', border:'1px solid rgba(99,102,241,0.3)', borderRadius:8, padding:'8px 12px', marginBottom:12, fontSize:12, color:'var(--primary-light)', fontWeight:600 }}>
                ⚡ Razorpay — Instant activation on payment
              </div>
              <div className="flex gap-2">
                <button className="btn btn-secondary btn-sm" onClick={() => openModal(p)}>✏️ Edit</button>
                <button className="btn btn-danger btn-sm" onClick={() => del(p.id)}>🗑️</button>
              </div>
            </div>
          ))}
          {plans.length === 0 && <div className="card text-center text-muted" style={{ gridColumn:'1/-1' }}>No plans yet. Add your first plan!</div>}
        </div>
      </div>

      {modal && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth:500 }}>
            <h2>{editId ? '✏️ Edit Plan' : '➕ New Plan'}</h2>
            <form onSubmit={save}>
              <div className="form-group"><label>Plan Name *</label><input value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Basic Plan" required /></div>
              <div className="form-group"><label>For Role *</label>
                <select value={form.role} onChange={e => set('role', e.target.value)}>
                  <option value="science_teacher">Science Teacher</option>
                  <option value="arts_teacher">Arts Teacher</option>
                  <option value="school">School / Coaching</option>
                </select>
              </div>
              <div className="grid-2">
                <div className="form-group"><label>Duration (days) *</label><input type="number" value={form.duration_days} onChange={e => set('duration_days', +e.target.value)} required /></div>
                <div className="form-group"><label>Exam Limit *</label><input type="number" value={form.exam_limit} onChange={e => set('exam_limit', +e.target.value)} required /></div>
              </div>
              <div className="grid-2">
                <div className="form-group"><label>Price (₹) *</label><input type="number" value={form.price} onChange={e => set('price', +e.target.value)} required /></div>
                <div className="form-group"><label>🤖 AI Credits</label><input type="number" value={form.ai_credits} onChange={e => set('ai_credits', +e.target.value)} min={0} /></div>
              </div>
              <div className="form-group"><label>Description</label><textarea value={form.description} onChange={e => set('description', e.target.value)} rows={2} placeholder="Optional short description" /></div>

              <div style={{ background:'rgba(99,102,241,0.08)', border:'1px solid rgba(99,102,241,0.25)', borderRadius:10, padding:14, marginBottom:16, fontSize:13, color:'var(--text2)' }}>
                ⚡ Payment will be collected automatically via <strong style={{ color:'var(--primary-light)' }}>Razorpay</strong> for ₹{form.price}. No manual setup needed.
              </div>

              <div className="flex gap-2">
                <button type="submit" className="btn btn-primary btn-full">💾 Save Plan</button>
                <button type="button" className="btn btn-secondary" onClick={() => setModal(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
